import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67a92c9e&scoped=true&functional=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=67a92c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "67a92c9e",
  null
  
)

export default component.exports